import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "role-card-achievement-talent"
};
const _hoisted_2 = {
  class: "content-container"
};
const _hoisted_3 = {
  class: "group-container"
};
const _hoisted_4 = {
  class: "group-title"
};
const _hoisted_5 = {
  key: 0,
  class: "empty-data-container"
};
const _hoisted_6 = {
  class: "empty-data-tips"
};
const _hoisted_7 = {
  key: 1,
  class: "data-container"
};
const _hoisted_8 = ["id"];
const _hoisted_9 = {
  class: "feats-source"
};
const _hoisted_10 = {
  class: "feats-desc"
};
const _hoisted_11 = {
  class: "feats-org"
};
const _hoisted_12 = {
  class: "group-container"
};
const _hoisted_13 = {
  key: 0,
  class: "empty-data-container"
};
const _hoisted_14 = {
  key: 1,
  class: "data-container"
};
const _hoisted_15 = ["id"];
const _hoisted_16 = {
  class: "title-container"
};
const _hoisted_17 = {
  class: "sub-title"
};
const _hoisted_18 = {
  class: "desc"
};
const _hoisted_19 = {
  class: "from"
};
const _hoisted_20 = {
  key: 0,
  class: "transition-container"
};
const _hoisted_21 = {
  class: "transition-talent-title"
};
const _hoisted_22 = {
  class: "transition-talent-desc"
};
import { computed, onMounted, watch } from 'vue';
import { ElCol, ElRow } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
import { Medal, Present, Link } from "@element-plus/icons-vue";
export default {
  __name: 'RoleCardAchievementTalent',
  props: {
    roleId: {
      type: [String, Number],
      required: true
    }
  },

  setup(__props) {
    const props = __props;
    const attribute = computed(() => store.state.role_info[props.roleId]?.attribute ?? null);
    const organizationNature = computed(() => {
      const organizations = attribute.value?.organizations ?? [];
      const buffer = organizations.filter(item => item['is_core']);
      if (buffer.length === 0) return -1;
      return ![0, 1].includes(parseInt(buffer[0]?.nature ?? -1));
    });
    const roleFeats = computed(() => store.state.role_info[props.roleId]?.role_feats ?? null);
    const roleTalents = computed(() => store.state.role_info[props.roleId]?.role_talents ?? null);
    onMounted(() => {
      getData();
    });

    const getData = () => {
      getRoleFeats();
      getRoleTalents();
    };

    const getRoleFeats = () => {
      if (!roleFeats.value) {
        request('role/role_feats/get/', {
          'role_id': props.roleId
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_role_info', {
              role_id: props.roleId,
              key: 'role_feats',
              value: response.data
            });
          }
        });
      }
    };

    const getRoleTalents = () => {
      if (!roleTalents.value) {
        request('role/role_talents/get/', {
          'role_id': props.roleId
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_role_info', {
              role_id: props.roleId,
              key: 'role_talents',
              value: response.data
            });
          }
        });
      }
    };

    const getTransitionArray = item => {
      const {
        transition,
        ...data
      } = item; // console.log('getTransitionArray ', JSON.stringify(data.name))

      if (!transition) {
        return [data];
      }

      return [data, ...getTransitionArray(transition)];
    };

    const getTitleDesc = item => {
      let tierStr = '';

      switch (item['tier']) {
        case 1:
          tierStr = 'I';
          break;

        case 2:
          tierStr = 'II';
          break;

        case 3:
          tierStr = 'III';
          break;

        case 4:
          tierStr = '传奇';
          break;
      }

      let title = item['name'] ?? '';

      if (tierStr.length !== 0) {
        title += `【${tierStr}】`;
      }

      let typeStr = item?.type?.desc ?? '';

      if (typeStr.length !== 0) {
        title += `【${typeStr}类】`;
      }

      return title;
    };

    const getContentDesc = item => {
      if (item['performance']) {
        return `${item['performance']['name']} / ${item['performance']['date']}`;
      } else {
        return `雾海 / ${item['date']}`;
      }
    };

    const getItemGrowable = item => {
      return item['growable'] ? '可晋升' : '';
    }; // watcher


    watch(() => props.roleId, () => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_image = _resolveComponent("el-image");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElRow), {
        style: {
          "width": "100%",
          "align-items": "center",
          "justify-content": "space-between"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          style: {
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            size: 18
          }, {
            default: _withCtx(() => [organizationNature.value ? (_openBlock(), _createBlock(_unref(Medal), {
              key: 0
            })) : (_openBlock(), _createBlock(_unref(Link), {
              key: 1
            }))]),
            _: 1
          }), _createElementVNode("text", _hoisted_4, _toDisplayString(organizationNature.value ? '角色功勋' : '神性链接'), 1)]),
          _: 1
        })]),
        _: 1
      }), !roleFeats.value || roleFeats.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("text", _hoisted_6, " 未发现" + _toDisplayString(organizationNature.value ? '功勋' : '链接') + "数据 ", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleFeats.value, (item, key) => {
        return _openBlock(), _createElementBlock("div", {
          class: "feats-card",
          id: key,
          key: `feats-${__props.roleId}-${item['id']}`
        }, [_createVNode(_component_el_image, {
          class: "org-emblem",
          src: item.organization.emblem,
          draggable: "false"
        }, null, 8, ["src"]), _createElementVNode("text", _hoisted_9, _toDisplayString(item.performance.id ? `${item.performance.name} / ${item.performance.end_date}` : `雾海 / ${item.update_time}`), 1), _createElementVNode("text", _hoisted_10, [_createTextVNode(" 因\"" + _toDisplayString(item.desc) + "\"，得到  ", 1), _createElementVNode("span", _hoisted_11, _toDisplayString(item.organization.name ?? '雾海'), 1), _cache[0] || (_cache[0] = _createTextVNode("  嘉奖 ", -1))])], 8, _hoisted_8);
      }), 128))]))]), _createElementVNode("div", _hoisted_12, [_createVNode(_unref(ElRow), {
        style: {
          "width": "100%",
          "align-items": "center",
          "justify-content": "space-between"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          style: {
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            size: 18
          }, {
            default: _withCtx(() => [_createVNode(_unref(Present))]),
            _: 1
          }), _cache[1] || (_cache[1] = _createElementVNode("text", {
            class: "group-title"
          }, "角色天赋", -1))]),
          _: 1
        })]),
        _: 1
      }), !roleTalents.value || roleTalents.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[2] || (_cache[2] = [_createElementVNode("text", {
        class: "empty-data-tips"
      }, "未发现天赋数据", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleTalents.value, (item, key) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["talent-card", [item['tier'] > 0 ? `talent-border-${item['tier']}` : '']]),
          id: key,
          key: `talent-${__props.roleId}-${item['id']}`
        }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("text", {
          class: _normalizeClass(['title', item['tier'] > 0 ? `title-tier-${item['tier']}` : ''])
        }, _toDisplayString(getTitleDesc(item)), 3), _createElementVNode("text", _hoisted_17, _toDisplayString(getItemGrowable(item)), 1)]), _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _createVNode(_unref(ElCol), null, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_18, _toDisplayString(item['desc']), 1)]),
            _: 2
          }, 1024), _createVNode(_unref(ElRow), {
            style: {
              "justify-content": "flex-end",
              "margin-top": "1.0rem"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_19, _toDisplayString(getContentDesc(item)), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), item['transition'] ? (_openBlock(), _createElementBlock("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTransitionArray(item.transition), (transitionItem, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "transition-item"
          }, [_createElementVNode("text", _hoisted_21, [_createTextVNode(_toDisplayString(getTitleDesc(transitionItem)) + "  —— " + _toDisplayString(getContentDesc(transitionItem)) + " ", 1), _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", _hoisted_22, _toDisplayString(transitionItem.desc), 1)])]);
        }), 128))])) : _createCommentVNode("", true)], 10, _hoisted_15);
      }), 128))]))])])]);
    };
  }

};